import {appHasCapability} from '../utils/app.js';
import {setCoachMark} from '../utils/coachmark.js';

const setGridGangaSwitch = async () => {
    const hideSwitch = !await appHasCapability('ganga-style-v2');
		document.querySelectorAll('.js-ganga-switch').forEach(switchy => {
      if (hideSwitch) {
        switchy.remove();
      } else {
        setCoachMark('coach-mark-ganga', switchy);
        const input = switchy.querySelector('input');
        input.addEventListener('change', () => {
          const searchParams = new URLSearchParams(window.location.search);
          if (input.checked) {
            searchParams.set('fair_price', '1');
          } else {
            searchParams.delete('fair_price');
          }
          if (!searchParams.get('jsnav')) {
            searchParams.set('jsnav', '1');
          }
          
          if (window.location.pathname === '/') { // La home de la app no admite filtros y redireccionamos a /mujer
            window.location =
                new URL('/mujer?' + searchParams.toString(), window.origin);
            setTimeout(() => { // Desmarcamos el toggle para mantener coherencia con el feed si la user vuelve atrás
              input.checked = false;
            }, 3000);
          } else {
            window.location.search = searchParams.toString();
          }
        });
      }
		});
  };

export {setGridGangaSwitch};